// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#infoTable tr td:first-child {
  padding-right: 15px;
}

.h35 {
  height: 35px;
}

.h55 {
  height: 55px;
}

.topMenu {
  background-color: #EDF2F5;
  margin: 0 0 auto 102px;
  min-width: 550px;
  padding: 20px;
  border-bottom: 1px solid #ddd;
  z-index: 1;
}

.topHead {
  padding-top: 0;
  margin-top: 0;
  height: 50px;
  font-size: 70%;
}

.numberBox {
  background-color: #bbb;
  color: white;
  font-weight: bold;
  padding: 0 6px;
  margin-left: 10px;
  border-radius: 3px;
  min-width: 25px;
  text-align: center;
}

/**
@media (max-height:  725px ) {
    #informations {
        display: none;
    }
    #informationAltTitle {
        display: block !important;
    }
}



#informationAltTitle {
    display: none;
}

*/
/** affixing **/
.top {
  background-color: #F7F5F2;
  top: 0;
  z-index: 50 !important;
}

.fluid {
  position: relative;
  top: 125px;
}

.semiFluid {
  position: relative;
  top: 125px;
}

.blockBottom {
  position: fixed;
  padding-top: 20px;
}

.bbLeft {
  left: 102px;
  padding: 35px 20px 0 20px;
}

.bbRight {
  padding-right: 40px;
}

.cardEvaluation {
  padding-left: 2px;
  width: 63px;
  height: 63px;
  margin: 0 auto;
}

.cardEvaluationTitle {
  text-align: center;
}

.modalButton {
  background-color: white;
  color: #111111;
}

.modalButton:hover {
  background-color: #EDF2F5;
}

.h3link {
  cursor: pointer;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/components/administration-account-left-sidebar/administration-account-left-sidebar.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EAEA,UAAA;AAAJ;;AAGA;EACI,cAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAAJ;;AAGA;;;;;;;;;;;;;;;;CAAA;AAkBA,eAAA;AAEA;EACI,yBAAA;EACA,MAAA;EACA,sBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,eAAA;EACA,iBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,mBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,uBAAA;EACA,cAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;EACI,eAAA;EACA,mBAAA;AAFJ","sourcesContent":["#infoTable tr td:first-child {\n    padding-right: 15px;\n}\n\n.h35 {\n    height: 35px;\n}\n\n.h55 {\n    height: 55px;\n}\n\n.topMenu {\n    background-color: #EDF2F5;\n    margin: 0 0 auto 102px;\n    min-width: 550px;\n    padding: 20px;\n    border-bottom: 1px solid #ddd;\n    // nécéssaire pour que topMenu soit sous les backdrop de modal\n    z-index: 1;\n}\n\n.topHead {\n    padding-top: 0;\n    margin-top: 0;\n    height: 50px;\n    font-size: 70%;\n}\n\n.numberBox {\n    background-color: #bbb;\n    color: white;\n    font-weight: bold;\n    padding: 0 6px;\n    margin-left: 10px;\n    border-radius: 3px;\n    min-width: 25px;\n    text-align: center;\n}\n\n/**\n@media (max-height:  725px ) {\n    #informations {\n        display: none;\n    }\n    #informationAltTitle {\n        display: block !important;\n    }\n}\n\n\n\n#informationAltTitle {\n    display: none;\n}\n\n*/\n\n/** affixing **/\n\n.top {\n    background-color: #F7F5F2;\n    top: 0;\n    z-index: 50 !important;\n}\n\n.fluid {\n    position: relative;\n    top: 125px;\n}\n\n.semiFluid {\n    position: relative;\n    top: 125px;\n}\n\n.blockBottom {\n    position: fixed;\n    padding-top: 20px;\n}\n\n.bbLeft {\n    left: 102px;\n    padding: 35px 20px 0 20px;\n}\n\n.bbRight {\n    padding-right: 40px;\n}\n\n.cardEvaluation {\n    padding-left: 2px;\n    width: 63px;\n    height: 63px;\n    margin: 0 auto;\n}\n\n.cardEvaluationTitle {\n    text-align: center\n}\n\n.modalButton {\n    background-color: white;\n    color: #111111;\n}\n\n.modalButton:hover {\n    background-color: #EDF2F5;\n}\n\n.h3link {\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
